import { Avatar } from "./ui/Avatar";

export function AvatarStack({
  primaryUrl,
  primaryName,
  otherUrls,
  otherNames,
  size = "sm",
}: {
  primaryUrl?: string;
  primaryName: string;
  otherUrls?: string[];
  otherNames?: string[];
  /**
   * `xs` shrinks the faces from 32px to 24px and tightens the overlap to
   * match (OSO-605).
   *
   * For a stack that sits beside a sentence which already names everybody in
   * it, three 32px faces were 80px of a 320px row, and the sentence they
   * squeezed wrapped onto a third line. A DM row keeps the default: there the
   * faces are the only thing identifying the conversation, so they are the
   * content rather than an ornament beside it.
   */
  size?: "xs" | "sm";
}) {
  const extras = otherUrls?.slice(0, 2) ?? [];
  if (extras.length === 0) {
    return <Avatar url={primaryUrl} name={primaryName} size={size} />;
  }

  return (
    <div className={`flex ${size === "xs" ? "-space-x-1.5" : "-space-x-2"} shrink-0`}>
      <div className="relative z-10 ring-2 ring-surface rounded-full">
        <Avatar url={primaryUrl} name={primaryName} size={size} />
      </div>
      {extras.map((url, i) => (
        <div key={i} className="relative ring-2 ring-surface rounded-full" style={{ zIndex: 9 - i }}>
          <Avatar url={url} name={otherNames?.[i] ?? ""} size={size} />
        </div>
      ))}
    </div>
  );
}
